import { fetchVisitorProfile } from "./visitorProfile";

let currentPermissions = null;

export const getPermissionsSnapshot = () => currentPermissions;

export const canChangeLinePrice = () =>
  currentPermissions?.can_change_line_price === true;

export const canWorkCalendar = () =>
  currentPermissions?.can_work_calendar === true;

export const canOrderOutsideCreditDays = () =>
  currentPermissions?.can_order_outside_credit_days === true;

export const canInvoiceDiscount = () =>
  currentPermissions?.invoice_discount === true;

export const fetchPermissions = async (axios, baseUrl, { force = false } = {}) => {
  if (!force && currentPermissions) {
    return currentPermissions;
  }

  const profile = await fetchVisitorProfile(axios, baseUrl, { force });
  currentPermissions = profile?.permissions || null;
  return currentPermissions;
};
